import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * Triangle with sliders directly targeting element parameters.
 *
 * Two sliders control sides a and b of a SAS triangle (fixed angle C = 60°).
 * Demonstrates the element-param targeting path (e.g. `param: 't1.a'`).
 */
export const SLIDER_SUM_PRESET: GeometryPadWidgetConfig = {
  id: 'slider-sum',
  type: 'geometrypad',
  params: {
    elements: {
      t1: {
        type: 'Triangle',
        params: { a: 4, b: 6, gamma: 60 },
      },
    },
  },
  display: {
    geometry: {
      shape: { coloring: true },
      label: { coloring: true, names: 'tiered', values: 'tiered' },
    },
  },
  behavior: {
    controls: [
      {
        id: 'slider-a',
        type: 'slider',
        label: 'Side a',
        param: 't1.a',
        range: [1, 10, 0.1],
        defaultValue: 4,
        editable: true,
        color: 'pink',
      },
      {
        id: 'slider-b',
        type: 'slider',
        label: 'Side b',
        param: 't1.b',
        range: [1, 10, 0.1],
        defaultValue: 6,
        editable: true,
        color: 'teal',
      },
    ],
  },
};
